import { AppButton, AppTextField } from 'components';
import UserSelect from 'components/molecules/UserSelect';
import useChapterMindmap from 'hooks/API/GET/useChapterMindmap';
import useManageMindMap from 'hooks/API/useManageMindMap';
import useToaster from 'hooks/useToaster';
import MindMapCommentDropBox from 'pages/manage-quiz/manage/Questions/MindMapCommentDropBox';
import * as React from 'react';
// import { AiOutlineEye } from 'react-icons/ai';
// import { BsFillTrashFill } from 'react-icons/bs';
import { FcPlus } from 'react-icons/fc';
import { HiExternalLink } from 'react-icons/hi';
import { MdOutlinePreview } from 'react-icons/md';
import { useParams } from 'react-router-dom';
import { ROLES } from 'utilities/constants';
import { getRandomUid } from 'utilities/uuid.service';
import * as AppPics from 'assets/images';
import MindMapReviewDrpDwn from '../MindMapDropDown';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { AiOutlineComment } from 'react-icons/ai';
import { useRouteMatch } from 'react-router-dom';
import useGetMindMap from 'hooks/API/GET/useGetMindMap';
import { notifier } from 'components/Toaster';
import BasicDelete from 'components/molecules/Modal/Delete/BasicDelete';

const actionsConfig = {
  open: false,
  data: {},
  Header: null,
  Body: null,
  isDeleteOperation: false,
};

function TopicMindTreeTab({ data, subtopicID, userContext }) {
  const { courseID, chapterID, classID, topicID } = useParams();

  const [mindMapStatus, setMindMapStatus] = React.useState(`draft`);
  const [mindMapLink, setMindMapLink] = React.useState(``);
  const [assignedSe, setAssignedSe] = React.useState();
  const [disabledOptions, setDisabledOptions] = React.useState([]);
  const [assignedTutor, setAssignedTutor] = React.useState();
  const [feedbackLinks, setFeedbackLinks] = React.useState([]);
  const [qBox, setQBox] = React.useState({ open: false, data: {} });
  const [actions, setActions] = React.useState({ ...actionsConfig });

  const { url } = useRouteMatch();

  const { userPermissions = {}, userInfo = {} } = userContext;
  const isTeacher = userInfo?.data?.key === ROLES.TUTOR;
  const isSE = userInfo?.data?.key === ROLES.SUBJECT_EXPERT;
  const isAdmin = userInfo?.data?.key === ROLES.ADMIN;

  const __params = {};
  if (subtopicID) __params.subtopicID = subtopicID;
  const { isLoading: isFetchingMM, data: mindMapsData } = useChapterMindmap({
    courseID,
    chapterID,
    configs: { params: { topicID, ...__params } },
    enabled: !!(courseID && chapterID),
  });
  const {
    data: mindMapRecord,
    isLoading,
    isError,
  } = useGetMindMap({ courseId: courseID, chapterId: chapterID, enabled: true });
  // useToaster(isLoading, { type: isError ? 'error' : 'success' });

  const { mutate: deleteMindMapMutation } = useManageMindMap({
    courseId: courseID,
    chapterId: chapterID,
  });

  const [showTeacherUser, setShowTeacherUser] = React.useState(
    mindMapsData?.data?.assignedTutorForReview ||
      (mindMapsData?.data?.status === 'teacher_review' ? true : false) ||
      false
  ); // as well teacher user is filled in
  React.useEffect(() => {
    if (mindMapsData?.data) {
      if (Array.isArray(mindMapsData?.data?.feedbackLinks)) {
        setFeedbackLinks(mindMapsData?.data?.feedbackLinks?.map((x) => ({ ...x, id: x._id })));
      }
      setMindMapLink(mindMapsData?.data?.mindMapLink ?? '');
      setQBox({ ...qBox, data: mindMapsData?.data?.mindMapReviews });
      setMindMapStatus(mindMapsData?.data?.status ?? 'draft');
      setAssignedSe(mindMapsData?.data?.contentMaintainedBy);
      setAssignedTutor(mindMapsData?.data?.assignedTutorForReview);
      if (
        mindMapsData?.data?.assignedTutorForReview ||
        mindMapsData?.data?.status === 'teacher_review'
      )
        setShowTeacherUser(true);
      setDisabledOptions(mindMapsData?.data?.dropDownDisable ?? []);
    }
  }, [mindMapsData?.data]);

  // Delete mind map
  const handleDelete = (podcast) => {
    setActions({
      open: true,
      data: { id: podcast._id },
      Header: 'Delete Mind Tree',
      Body: `Are you sure you want to delete mind tree?`,
      isDeleteOperation: true,
    });
  };

  const handleDeleteMindmap = () => {
    deleteMindMapMutation(
      { type: 'DELETE' },
      {
        onSuccess: (response) =>
          notifier.success(response?.data?.data?.message || response?.data?.message),
        onError: (failData) => {
          const errorData = failData?.response?.data;
          notifier.error(errorData?.message);
        },
      }
    );
    setActions({ ...actionsConfig });
  };

  // function handleSave() {
  //   if (isLoading) return;
  //   const __se = assignedSe?._id || assignedSe?._id;
  //   const __tutor = assignedTutor?._id || assignedTutor?._id;
  //   if (mindMapStatus === 'review' && !__se) {
  //     alert('Subject expert must be selected.');
  //     return;
  //   }
  //   if (mindMapStatus === 'teacher_review' && (!__se || !__tutor)) {
  //     alert('Subject expert and Teacher user must be selected.');
  //     return;
  //   }
  //   if (!mindMapLink) {
  //     alert('Mindmap Link is missing.');
  //     return;
  //   }

  //   const __apiData = {
  //     courseID,
  //     chapterID,
  //     classID,
  //     topicID,
  //     mindMapLink,
  //     feedbackLinks,
  //     mindMapStatus,
  //     minpMapAssignedSe: assignedSe?.id,
  //     mindMapAssignedTutor: assignedTutor?.id,
  //   };

  //   if (subtopicID) __apiData.subtopicID = subtopicID;

  //   mutate(__apiData);
  // }
  React.useEffect(() => {
    if (mindMapStatus === 'teacher_review') {
    }
    return () => {};
  }, [mindMapStatus]);

  return (
    <>
      <BasicDelete
        open={actions.open}
        closeModal={() => setActions({ ...actionsConfig })}
        Header={actions.Header}
        Body={actions.Body}
        handleConfirmation={handleDeleteMindmap}
      />
      {qBox.open && (
        <MindMapCommentDropBox
          open={qBox.open}
          data={{ ...qBox?.data }}
          close={() => {
            setQBox({ open: false, data: {} });
          }}
        />
      )}
      <div className="container">
        {true && (
          <div className="row">
            <div className="col-6 publishheader">
              <h2 className="prime-head p-0 boldtitle">Add mind tree (Chapter Based)</h2>
            </div>
            <div className="col-6 publishheader">
              {/* Live Preview button — same pattern as Notes tab */}
              <a
                href={`${process.env.REACT_APP_PREVIEW_URL.replace(/\/$/, '')}/sneak-peak?course=${courseID}&chapter=${chapterID}&tab=mindmap`}
                role={'button'}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-plane g--tint ml-4 d-flex align-items-center float-right"
              >
                {' '}
                Live Preview <MdOutlinePreview className="mx-2" size={24} />
              </a>
              {(mindMapsData?.data?.mindMapReviews ||
                (isTeacher && mindMapStatus === 'teacher_review')) && (
                <AppButton
                  variantClass="lessonWrap__btn float-right"
                  style={{ fontSize: '22px', verticalAlign: 'middle' }}
                  onClick={() => {
                    setQBox({ ...qBox, data: mindMapsData?.data?.mindMapReviews, open: true });
                  }}
                >
                  <AiOutlineComment color="#7e1f8c" />
                </AppButton>
              )}
            </div>
          </div>
        )}

        {isFetchingMM ? (
          <div className="row">Loading...</div>
        ) : (
          <>
            <div className="row">
              <div className="col-6">
                {(isSE || isAdmin) && (
                  // <AppTextField
                  //   labelProps={{ label: 'Mind map link' }}
                  //   inputProps={{
                  //     placeholder: 'add the link here',
                  //     value: mindMapLink,
                  //     onChange: (event) => {
                  //       const value = event.target.value;
                  //       setMindMapLink(value);
                  //     },
                  //   }}
                  // />
                  <>
                    <label className="label d-block">Add Mind tree *</label>
                    <Link to={`${url}/mind-tree/add`}>
                      <AppButton variantClass="btn btn-primary">
                        {mindMapRecord?.data?.data ? 'Update Mind tree' : 'Add Mind tree'}
                      </AppButton>
                    </Link>
                    {mindMapRecord?.data?.data && (
                      <div className="mt-4">
                        <Link
                          to={`${url}/mind-tree/add`}
                          className="__appColor"
                          style={{
                            fontSize: '13px',
                            letterSpacing: '1px',
                            textDecoration: 'underline',
                            textDecorationStyle: 'dotted',
                            textDecorationLine: 'underline',
                            textDecorationThickness: '3px',
                            width: '100%',
                            fontStyle: 'italic',
                          }}
                        >
                          Click to View Mind tree
                        </Link>

                        <AppButton
                          className="actions-icons mx-4 text-danger"
                          title="Delete"
                          onClick={() => handleDelete(mindMapRecord?.data?.data)}
                        >
                          <img src={AppPics.DeleteSvg} alt="delete" style={{ height: '16px' }} />
                        </AppButton>
                      </div>
                    )}
                  </>
                )}
                {/* {isTeacher && mindMapLink && (
                  <>
                    <label>Mind map link</label>
                    <div className="row">
                      <div className="col-md-6 col-sm-12 my-4">
                        <HiExternalLink />{' '}
                        <a href={mindMapLink} target="_blank" rel="noopener noreferrer">
                          {mindMapLink}
                        </a>
                      </div>
                    </div>
                  </>
                )} */}
              </div>

              {/* <div className="col-6">
                <MindMapReviewDrpDwn
                  selectProps={{
                    disabled: false, //!__teacherVisitedAllQuestions || !__teacherRatedAllQuestions,
                  }}
                  area={{
                    reviewOptions: (userPermissions?.mindmap?.dropDownOptions ?? []).map((r) => {
                      if (disabledOptions?.length > 0 && disabledOptions?.includes?.(r.value))
                        r.isDisabled = true;
                      else r.isDisabled = false;
                      return r;
                    }),
                  }}
                  value={mindMapStatus}
                  onChange={(value) => {
                    setMindMapStatus(value);
                    if (value === 'teacher_review') setShowTeacherUser(true);
                    else setShowTeacherUser(false);
                  }}
                />
                <label>Status</label>
                  <select
                    value={mindMapStatus}
                    onChange={(event) => {
                      setMindMapStatus(event.target.value);
                      if (event.target.value === 'teacher_review') setShowTeacherUser(true);
                      else setShowTeacherUser(false);
                    }}
                  >
                    <option value="draft">Draft</option>
                    <option value="review">Assign to Subject expert for review</option>
                    <option value="teacher_review">Assign to Teacher for review</option>
                  </select>
              </div> */}
            </div>
            {/* <div className="row  mt-4">
              {!isTeacher && (
                <div className="col-6">
                  <label htmlFor={'seOwner'}>Pick a Subject expert </label>
                  <UserSelect
                    dependencies={{ query: { roles: [ROLES.SUBJECT_EXPERT] } }}
                    handleChange={setAssignedSe}
                    values={assignedSe}
                    isMulti={false}
                  />
                </div>
              )}
              {showTeacherUser && !isTeacher && (
                <div className="col-6">
                  <label htmlFor={'SeTutor'}>Pick a Teacher</label>
                  <UserSelect
                    dependencies={{ query: { roles: [ROLES.TUTOR] } }}
                    handleChange={setAssignedTutor}
                    values={assignedTutor}
                    isMulti={false}
                  />
                </div>
              )}
            </div> */}

            {/* {(isSE || isAdmin) && feedbackLinks.length > 0 && (
              <>
                <h3 className="prime-head p-0 my-4">
                  Feedback links (listed based on first come basis)
                </h3>
                <div className="row">
                  {feedbackLinks.map((fb, index) => {
                    return (
                      <div
                        className="col-md-6 col-sm-12 my-4 d-flex align-items-center"
                        key={fb.id}
                      >
                        <span className="mx-2">{index + 1}.</span> <HiExternalLink />{' '}
                        <a
                          href={fb.value}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="mx-2"
                        >
                          {fb.value}
                        </a>
                      </div>
                    );
                  })}
                </div>
              </>
            )} */}
            {/* this feedback concept is no longer needed */}
            {/* {false === true && isTeacher && mindMapLink && (
              <>
                <div className="row">
                  {feedbackLinks.map((fb, index) => {
                    return (
                      <div className="col-md-6 col-sm-12 my-4" key={fb.id}>
                        <AppTextField
                          labelProps={{ label: `Feedback link ${index + 1}` }}
                          inputProps={{
                            placeholder: 'add the link here',
                            value: fb.value,
                            onChange: (event) => {
                              const value = event.target.value;
                              setFeedbackLinks(
                                feedbackLinks.map((f) => {
                                  if (f.id === fb.id) f.value = value;
                                  return f;
                                })
                              );
                            },
                          }}
                        />
                        {feedbackLinks.length > 1 && (
                          <div
                            className="text-right text-danger"
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setFeedbackLinks(feedbackLinks.filter((f) => f.id !== fb.id));
                            }}
                          >
                            <small className="text-muted">
                              <em>Delete</em>
                            </small>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                <button
                  type="button"
                  className="btn-plane g--tint d-flex align-items-center"
                  onClick={() => {
                    setFeedbackLinks(feedbackLinks.concat({ id: getRandomUid(), value: `` }));
                  }}
                  title="Click to add feedback links"
                >
                  <FcPlus className="mx-2" />
                  Click to add feedback links
                </button>
              </>
            )} */}

            {/* {(isSE || isTeacher || isAdmin) && (
              <div className="row mt-5 btnsubmitmain">
                <div className="col-12 btnTab-foot">
                  <button
                    type="button"
                    className="btn-right-content save"
                    onClick={() => {
                      handleSave();
                    }}
                  >
                    Save Changes
                  </button>
                </div>
                <div className="col-6 btnTab-foot">
                  {(mindMapsData?.data?.mindMapReviews ||
                    (isTeacher && mindMapStatus === 'teacher_review')) && (
                    <Link
                      role="button"
                      onClick={(e) =>
                        setQBox({ ...qBox, data: mindMapsData?.data?.mindMapReviews, open: true })
                      }
                      className="btn-right-content mx-2"
                    >
                      Open comments
                      <img src={AppPics.ReviewHistory} className="_sv_ico" alt="" />
                    </Link>
                  )}
                </div>
              </div>
            )} */}
          </>
        )}
      </div>
    </>
  );
}

export default TopicMindTreeTab;
